import { render, staticRenderFns } from "./categoryStatistics.vue?vue&type=template&id=3d79dc6d&scoped=true"
import script from "./categoryStatistics.vue?vue&type=script&lang=js"
export * from "./categoryStatistics.vue?vue&type=script&lang=js"
import style0 from "./categoryStatistics.vue?vue&type=style&index=0&id=3d79dc6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d79dc6d",
  null
  
)

export default component.exports